import React, { useState } from 'react';
import ModeManagementPanel from './ModeManagementPanel.jsx';
import SettingsViewSwitcher from './SettingsViewSwitcher.jsx';
import './settings-management.css';
import SkillManagementPanel from './SkillManagementPanel.jsx';

export default function SettingsManagementPanel({ skillManagement, modeManagement }) {
  const [viewMode, setViewMode] = useState('list');
  return (
    <section aria-label="配置" className="flare-settings-management">
      <header className="flare-settings-management-header">
        <h1 className="flare-settings-management-title">配置</h1>
        <SettingsViewSwitcher label="配置视图" setViewMode={setViewMode} viewMode={viewMode} />
      </header>
      <ModeManagementPanel modeManagement={modeManagement} viewMode={viewMode} />
      <SkillManagementPanel skillManagement={skillManagement} viewMode={viewMode} />
    </section>
  );
}
